import './Blog.css';

function Blog() {
  const articulos = [
    {
      titulo: 'Cómo tomar decisiones en contextos complejos',
      resumen:
        'Una reflexión sobre claridad, contexto y toma de decisiones.',
      fecha: 'Próximamente',
    },
    {
      titulo: 'La escucha como herramienta de transformación',
      resumen:
        'Por qué escuchar correctamente puede cambiar un proceso colectivo.',
      fecha: 'Próximamente',
    },
  ];

  return (
    <section className="pagina-blog">
      <header>
        <p>Blog</p>
        <h1>Ideas, experiencias y aprendizajes</h1>
      </header>

      <div className="articulos-container">
        {articulos.map((articulo) => (
          <article className="articulo-card" key={articulo.titulo}>
            <span>{articulo.fecha}</span>
            <h2>{articulo.titulo}</h2>
            <p>{articulo.resumen}</p>
            <button type="button">Leer artículo →</button>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Blog;